module.exports = __webpack_public_path__ + "static/benjamin-faust-8310-unsplash-96e76285d6ede6c4381e9592319b860b.jpg";